import { useState } from 'react'
import { useRemoteCollection } from 'civic-champs-shared/api/hooks'
import { useGroups } from './useGroups'
import useAddGroupPrompt from './useAddGroupPrompt'
import { useArchiveGroups } from './useArchiveGroups'

const useGroupsCollection = () => {
  const [groups, operations, events] = useRemoteCollection()
  const [initiallyLoaded, setInitiallyLoaded] = useState(false)
  const { syncCollection } = operations
  const { refetch } = useGroups(groups => {
    syncCollection(groups)
    setInitiallyLoaded(true)
  }, true)

  const addGroup = useAddGroupPrompt(operations.eagerAdd)
  const archiveGroups = useArchiveGroups(operations.eagerReplaceMany)

  return [
    {
      groups,
      initiallyLoaded,
    },
    {
      addGroup,
      archiveGroups,
      refresh: refetch,
    },
    events,
  ]
}

export default useGroupsCollection
